enum BrokerCommisionEnum {
  No = 'No',
  Yes = 'Yes',
  CallBroker = 'Call Broker',
}

export default BrokerCommisionEnum;
